export const p2eDigitConverter = (value: string) =>
  value.replace(/[۰-۹]/g, (number) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(number)))
